// Signup-source attribution. Reads utm_source / utm_medium / utm_campaign (or the
// short ?s=<code> fallback, e.g. ?s=li-dm) from the landing URL and keeps ONE
// string in sessionStorage until signup completes. No cookies, no third party,
// nothing sent anywhere until the user actually signs up. If the URL carries
// nothing, nothing is stored — there is no default.
const KEY = "signup_source";
const MAX_LEN = 64;

const clean = (v) =>
  String(v || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._/-]/g, "")
    .slice(0, MAX_LEN);

// utm params win (joined source/medium/campaign, whichever are present); else ?s=.
export function parseSignupSource(search) {
  const q = new URLSearchParams(search || "");
  const utm = ["utm_source", "utm_medium", "utm_campaign"].map((k) => clean(q.get(k))).filter(Boolean);
  if (utm.length) return utm.join("/").slice(0, MAX_LEN);
  return clean(q.get("s")) || null;
}

export function captureSignupSource(search = window.location.search) {
  try {
    const source = parseSignupSource(search);
    if (source) sessionStorage.setItem(KEY, source);
  } catch {
    // sessionStorage unavailable (private mode, blocked) — attribution is best-effort.
  }
}

export function getSignupSource() {
  try {
    return sessionStorage.getItem(KEY) || undefined;
  } catch {
    return undefined;
  }
}

export function clearSignupSource() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
